// extracted by mini-css-extract-plugin
module.exports = {"sameWidth":"styles_sameWidth__3XPqe"};